export const GET_HOROSCOPE = 'getHoroscope'
